export const SITE_URL = "https://svsnursingcollege.com";

export const ASSET_BASE =
  "https://customer-assets-agu9un31.emergentagent.net/job_health-ed-platform/artifacts/";

export const LABS = [
  {
    tag: "Pre-Clinical Sciences",
    name: "Pre Clinical Lab",
    desc: "Human anatomy models, specimens, charts and microscopes that bring foundational sciences to life.",
    img: ASSET_BASE + "gquz0zku_WhatsApp%20Image%202026-07-23%20at%204.10.27%20PM%20%281%29.jpeg",
  },
  {
    tag: "Fundamentals of Nursing",
    name: "Nursing Foundation Lab",
    desc: "Hospital-style beds and manikins for hands-on patient-care and bedside procedure training.",
    img: ASSET_BASE + "3gujvdfd_WhatsApp%20Image%202026-07-23%20at%204.10.28%20PM%20%285%29.jpeg",
  },
  {
    tag: "Advanced Practice",
    name: "Advance Nursing Lab",
    desc: "A dedicated space to practise advanced clinical procedures, patient care and core nursing skills with confidence.",
    img: ASSET_BASE + "fzds8kgj_WhatsApp%20Image%202026-07-23%20at%204.10.28%20PM%20%284%29.jpeg",
  },
  {
    tag: "Digital Learning",
    name: "Computer Lab",
    desc: "A modern computer lab supporting research, digital learning and online assessments.",
    img: ASSET_BASE + "turce0bo_WhatsApp%20Image%202026-07-22%20at%204.18.55%20PM.jpeg",
  },
  {
    tag: "Knowledge Centre",
    name: "Library",
    desc: "A spacious, well-stocked library with nursing texts, journals and quiet reading spaces for study and research.",
    img: ASSET_BASE + "dvhpt2i4_WhatsApp%20Image%202026-07-23%20at%204.10.29%20PM%20%283%29.jpeg",
  },
];

export const PARTNERS = [
  { name: "Medicant", img: ASSET_BASE + "34arfayc_WhatsApp%20Image%202026-07-24%20at%2011.46.16%20AM.jpeg" },
  { name: "Health Plus Hospital & Research Centre", img: ASSET_BASE + "okpb3t2o_WhatsApp%20Image%202026-07-24%20at%2011.46.15%20AM.jpeg" },
  { name: "Hill Candy Hospital", img: ASSET_BASE + "kjuj11px_WhatsApp%20Image%202026-07-24%20at%2011.46.15%20AM%20%282%29.jpeg" },
  { name: "wellMark Hospital", img: ASSET_BASE + "p3hxniud_WhatsApp%20Image%202026-07-24%20at%2011.46.15%20AM%20%281%29.jpeg" },
  { name: "Muskan Hospital & Research Center", img: ASSET_BASE + "wiuax5z1_WhatsApp%20Image%202026-07-24%20at%2011.46.14%20AM%20%281%29.jpeg" },
  { name: "Sadar Hospital, Bokaro", img: ASSET_BASE + "805b9gko_WhatsApp%20Image%202026-07-24%20at%2011.46.14%20AM.jpeg" },
];

export const PLACEMENTS = [
  { name: "Medicant", img: ASSET_BASE + "saq3cti3_WhatsApp%20Image%202026-08-25%20at%204.49.58%20PM%20%281%29.jpeg" },
  { name: "Sarvodaya Healthcare", img: ASSET_BASE + "ji8f9ykb_WhatsApp%20Image%202026-08-25%20at%204.49.58%20PM.jpeg" },
  { name: "Medanta", img: ASSET_BASE + "fiqcnucc_WhatsApp%20Image%202026-08-25%20at%204.49.59%20PM%20%281%29.jpeg" },
  { name: "Health Plus Hospital & Research Centre", img: ASSET_BASE + "0tlu6sp4_WhatsApp%20Image%202026-08-25%20at%204.49.59%20PM.jpeg" },
  { name: "wellMark Hospital", img: ASSET_BASE + "tq4pdf19_WhatsApp%20Image%202026-08-25%20at%204.50.00%20PM%20%281%29.jpeg" },
  { name: "Manipal Hospitals", img: ASSET_BASE + "1ea0q9kf_WhatsApp%20Image%202026-08-25%20at%204.50.01%20PM%20%281%29.jpeg" },
  { name: "Muskan Hospital & Research Center", img: ASSET_BASE + "jv09eg2j_WhatsApp%20Image%202026-08-25%20at%204.50.00%20PM.jpeg" },
  { name: "Hill Candy Hospital", img: ASSET_BASE + "ua9st4k9_WhatsApp%20Image%202026-08-25%20at%204.50.01%20PM.jpeg" },
];

export const RECOGNITIONS = [
  { name: "Indian Nursing Council (INC)", img: ASSET_BASE + "pxy71zj4_ChatGPT%20Image%20Jul%2024%2C%202026%2C%2001_02_58%20PM.png", desc: "Recognised by the national statutory body governing nursing education standards across India." },
  { name: "Jharkhand Nurses Registration Council", img: ASSET_BASE + "nm5mduh7_ChatGPT%20Image%20Jul%2024%2C%202026%2C%2001_00_48%20PM.png", desc: "Registered & regulated by the state council for nurses and midwives (Estd. 2003)." },
  { name: "Binod Bihari Mahto Koyalanchal University", img: ASSET_BASE + "ojqs0cy3_ChatGPT%20Image%20Jul%2024%2C%202026%2C%2001_09_05%20PM.png", desc: "Affiliated to the university based in Dhanbad, Jharkhand (Estd. 2017)." },
  { name: "Government of Jharkhand", img: ASSET_BASE + "zf106bpq_ChatGPT%20Image%20Jul%2024%2C%202026%2C%2001_17_11%20PM.png", desc: "Approved and supported under the Government of Jharkhand." },
];

export const PROGRAM_SLUGS = { "B.Sc": "bsc-nursing", GNM: "gnm", ANM: "anm" };

export const PROGRAM_DETAILS = {
  "bsc-nursing": {
    shortName: "B.Sc",
    path: "/programs/bsc-nursing",
    metaTitle: "B.Sc Nursing in Bokaro, Jharkhand | SVS College of Nursing",
    metaDescription:
      "Study B.Sc Nursing (4 years, 60 seats) at SVS College of Nursing, Bokaro — INC recognised, affiliated to BBMKU. Eligibility: 10+2 PCB with 45%. Admissions open 2026-27.",
    tagline:
      "A four-year professional degree that turns compassion into clinical expertise — the strongest foundation for a lifelong nursing career.",
    overview: [
      "The B.Sc. Nursing program at SVS College of Nursing is a four-year undergraduate degree designed to prepare competent, confident and compassionate professional nurses. The curriculum follows the Indian Nursing Council (INC) syllabus and is affiliated to Binod Bihari Mahto Koyalanchal University (BBMKU), Dhanbad.",
      "Students combine rigorous classroom learning with extensive clinical postings at our partner hospitals, gaining hands-on experience in medical-surgical, community, paediatric, obstetric and psychiatric nursing — graduating ready for hospital floors, government service and global opportunities.",
    ],
    study: [
      "Anatomy & Physiology",
      "Biochemistry & Nutrition",
      "Fundamentals of Nursing",
      "Medical-Surgical Nursing",
      "Pharmacology & Pathology",
      "Community Health Nursing",
      "Obstetrics & Gynaecological Nursing",
      "Child Health (Paediatric) Nursing",
      "Psychiatric & Mental Health Nursing",
      "Nursing Research & Management",
    ],
    careers: [
      "Staff Nurse in multi-specialty & super-specialty hospitals",
      "ICU, Emergency & Critical Care units",
      "Community Health Officer (CHO) in public health",
      "Nursing Tutor / Clinical Instructor",
      "Government, railway & defence nursing services",
      "International careers via licensing exams (NCLEX, IELTS/OET pathways)",
    ],
    faqs: [
      {
        q: "What is the duration of B.Sc Nursing at SVS College of Nursing?",
        a: "B.Sc. Nursing is a 4-year program including clinical rotations and internship, following the INC syllabus.",
      },
      {
        q: "What is the eligibility for B.Sc Nursing?",
        a: "10+2 with Physics, Chemistry, Biology and English with a minimum 45% aggregate, as per INC norms.",
      },
      {
        q: "Is the B.Sc Nursing program recognised?",
        a: "Yes. It is recognised by the Indian Nursing Council (INC), the Jharkhand Nurses Registration Council, and affiliated to BBMKU, Dhanbad.",
      },
      {
        q: "How many seats are available for B.Sc Nursing?",
        a: "60 seats per academic year.",
      },
      {
        q: "Does SVS provide placement after B.Sc Nursing?",
        a: "Yes. SVS offers a 100% placement guarantee through partner hospitals including Medanta, Manipal Hospitals and Sarvodaya Healthcare.",
      },
    ],
  },
  gnm: {
    shortName: "GNM",
    path: "/programs/gnm",
    metaTitle: "GNM Course in Bokaro, Jharkhand | SVS College of Nursing",
    metaDescription:
      "Study GNM (General Nursing & Midwifery) — 3 years, 60 seats — at SVS College of Nursing, Bokaro. INC recognised. Eligibility: 10+2 any stream with 40% in English. Admissions 2026-27 open.",
    tagline:
      "A three-year diploma built on hospital floors — hands-on clinical training from day one, ending in Registered Nurse eligibility.",
    overview: [
      "The General Nursing & Midwifery (GNM) program at SVS College of Nursing is a three-year diploma that prepares skilled nurses for hospitals, maternity care and community health. The program follows the INC syllabus and combines structured theory with extensive supervised clinical rotations.",
      "GNM graduates from SVS are eligible for registration as Registered Nurses and can progress to Post Basic B.Sc. Nursing — making it a direct, practical route into the nursing profession.",
    ],
    study: [
      "Biological Sciences",
      "Behavioural Sciences",
      "Fundamentals of Nursing",
      "First Aid & Emergency Care",
      "Medical-Surgical Nursing I & II",
      "Community Health Nursing",
      "Midwifery & Gynaecological Nursing",
      "Paediatric Nursing",
      "Supervised Clinical Internship",
    ],
    careers: [
      "Staff Nurse (GNM) in hospitals & nursing homes",
      "Maternity & obstetric ward nursing",
      "Primary & community health centres",
      "Home healthcare & elder care services",
      "Progression to Post Basic B.Sc. Nursing",
    ],
    faqs: [
      {
        q: "What is the duration of the GNM course at SVS?",
        a: "GNM is a 3-year diploma including supervised clinical internship.",
      },
      {
        q: "What is the eligibility for GNM?",
        a: "10+2 in any stream with a minimum of 40% in English, as per INC norms.",
      },
      {
        q: "Can GNM graduates become Registered Nurses?",
        a: "Yes. GNM graduates are eligible for registration as Registered Nurses with the Jharkhand Nurses Registration Council.",
      },
      {
        q: "How many seats are available for GNM?",
        a: "60 seats per academic year.",
      },
      {
        q: "Can I study further after GNM?",
        a: "Yes. GNM graduates can progress to Post Basic B.Sc. Nursing and beyond.",
      },
    ],
  },
  anm: {
    shortName: "ANM",
    path: "/programs/anm",
    metaTitle: "ANM Course in Bokaro, Jharkhand | SVS College of Nursing",
    metaDescription:
      "Study ANM (Auxiliary Nurse Midwife) — 2 years, 60 seats — at SVS College of Nursing, Bokaro. Eligibility: 10+2 in any stream. Community-health focused with strong rural employability. Admissions 2026-27 open.",
    tagline:
      "A two-year diploma for frontline community health — the fastest route into a respected healthcare career serving mothers, children and villages.",
    overview: [
      "The Auxiliary Nurse Midwife (ANM) program at SVS College of Nursing is a two-year diploma focused on community and primary healthcare. ANM professionals are the backbone of India's public health system — leading maternal and child health, immunisation and health-education work at the grassroots.",
      "With practical field training and a strong rural employability record, the ANM program at SVS prepares students for immediate, meaningful service in primary health centres, sub-centres and community health programs, with a clear pathway to GNM.",
    ],
    study: [
      "Health Promotion & Education",
      "Primary Health Care",
      "Child Health Nursing",
      "Midwifery",
      "Community Health & Nutrition",
      "Immunisation & Family Welfare",
      "Field Training & Supervised Practice",
    ],
    careers: [
      "Auxiliary Nurse Midwife at PHCs & sub-centres",
      "Maternal & child health programs",
      "Vaccination & public health drives",
      "NGOs & community health projects",
      "Progression to GNM and higher nursing education",
    ],
    faqs: [
      {
        q: "What is the duration of the ANM course at SVS?",
        a: "ANM is a 2-year diploma including field training and supervised practice.",
      },
      {
        q: "What is the eligibility for ANM?",
        a: "10+2 pass in any stream, as per INC norms.",
      },
      {
        q: "What does an ANM nurse do?",
        a: "ANM professionals lead maternal and child health, immunisation and health-education work in primary health centres and communities.",
      },
      {
        q: "How many seats are available for ANM?",
        a: "60 seats per academic year.",
      },
      {
        q: "Can I study further after ANM?",
        a: "Yes. ANM graduates can progress to GNM and then to higher nursing qualifications.",
      },
    ],
  },
};

export const COLLEGE_JSONLD = {
  "@type": "CollegeOrUniversity",
  name: "SVS College of Nursing",
  sameAs: SITE_URL,
  telephone: "+91 70913 55794",
  email: "svscollegeofnursing@gmail.com",
  address: {
    "@type": "PostalAddress",
    streetAddress: "Bahadurpur, Jainamore",
    addressLocality: "Bokaro Steel City",
    addressRegion: "Jharkhand",
    postalCode: "829144",
    addressCountry: "IN",
  },
};

export const LOCATION_PAGES = {
  dhanbad: {
    city: "Dhanbad",
    slug: "nursing-college-in-dhanbad",
    metaTitle: "Nursing College in Dhanbad — B.Sc, GNM & ANM | SVS College of Nursing",
    metaDescription:
      "Looking for a nursing college in Dhanbad? SVS College of Nursing, Bokaro — about an hour away — offers INC-recognised B.Sc Nursing, GNM and ANM with a 100% placement guarantee. Admissions open 2026-27.",
    tagline:
      "INC-recognised nursing programs about an hour from Dhanbad — with your degree affiliated to BBMKU, headquartered right in your city.",
    intro: [
      "Students from Dhanbad looking for a recognised, career-focused nursing college consistently choose SVS College of Nursing in Bokaro. Located roughly an hour away by road or train, SVS offers B.Sc. Nursing, GNM and ANM programs recognised by the Indian Nursing Council and the Jharkhand Nurses Registration Council.",
      "Your degree is affiliated to Binod Bihari Mahto Koyalanchal University (BBMKU) — headquartered in Dhanbad itself — and every program is backed by a 100% placement guarantee through our partner hospitals across Jharkhand and beyond.",
    ],
    why: [
      "Degree affiliated to BBMKU — the university headquartered in Dhanbad",
      "About an hour from Dhanbad by road or train",
      "Recognised by the Indian Nursing Council & Jharkhand Nurses Registration Council",
      "100% placement guarantee with leading partner hospitals",
      "Focused batches — just 60 seats per program for personal attention",
      "Modern labs and supervised clinical postings in Bokaro hospitals",
    ],
    travel:
      "SVS College of Nursing is at Bahadurpur, Jainamore, Bokaro — roughly an hour's journey from Dhanbad by road, with frequent train connections between Dhanbad and Bokaro Steel City.",
    faqs: [
      {
        q: "Which is a good INC-recognised nursing college near Dhanbad?",
        a: "SVS College of Nursing in Bokaro is recognised by the Indian Nursing Council and the Jharkhand Nurses Registration Council, and is about an hour from Dhanbad.",
      },
      {
        q: "How far is SVS College of Nursing from Dhanbad?",
        a: "The campus is in Bahadurpur, Jainamore, Bokaro — roughly an hour by road, with regular train connections from Dhanbad to Bokaro Steel City.",
      },
      {
        q: "Which university is the nursing degree affiliated to?",
        a: "Programs are affiliated to Binod Bihari Mahto Koyalanchal University (BBMKU), headquartered in Dhanbad.",
      },
      {
        q: "What programs can students from Dhanbad apply for?",
        a: "B.Sc. Nursing (4 years), GNM (3 years) and ANM (2 years) — 60 seats each, admissions open for 2026-27.",
      },
      {
        q: "Is placement guaranteed for students from Dhanbad?",
        a: "Yes. Every SVS student is covered by the 100% placement guarantee through partner hospitals including Medanta and Manipal Hospitals.",
      },
    ],
  },
  ranchi: {
    city: "Ranchi",
    slug: "nursing-college-in-ranchi",
    metaTitle: "Nursing College in Ranchi — B.Sc, GNM & ANM | SVS College of Nursing",
    metaDescription:
      "Searching for a nursing college in Ranchi? SVS College of Nursing, Bokaro offers INC-recognised B.Sc Nursing, GNM and ANM with 60 seats per program and a 100% placement guarantee. Admissions open 2026-27.",
    tagline:
      "A recognised, placement-assured nursing education within easy reach of Ranchi — smaller batches, modern labs and guaranteed career outcomes.",
    intro: [
      "For students in Ranchi searching for the right nursing college, SVS College of Nursing in Bokaro offers what crowded city institutions often cannot: focused 60-seat batches, INC-recognised programs and a 100% placement guarantee with leading hospitals.",
      "Well connected to Ranchi by road and rail, SVS delivers B.Sc. Nursing, GNM and ANM programs affiliated to Binod Bihari Mahto Koyalanchal University — with dedicated admissions counselling for outstation students at every step.",
    ],
    why: [
      "Well connected to Ranchi by road and rail — around three hours away",
      "Recognised by the Indian Nursing Council & Jharkhand Nurses Registration Council",
      "100% placement guarantee — recruiters across Jharkhand and metro cities",
      "Just 60 seats per program — personal mentorship, not crowded lecture halls",
      "State-of-the-art labs and real clinical postings in partner hospitals",
      "Dedicated admissions counselling for outstation students and families",
    ],
    travel:
      "SVS College of Nursing is at Bahadurpur, Jainamore, Bokaro — around three hours from Ranchi by road, with convenient train services connecting Ranchi and Bokaro Steel City.",
    faqs: [
      {
        q: "Is there a good nursing college near Ranchi with guaranteed placement?",
        a: "SVS College of Nursing in Bokaro offers INC-recognised B.Sc, GNM and ANM programs with a 100% placement guarantee, about three hours from Ranchi.",
      },
      {
        q: "How do I reach SVS College of Nursing from Ranchi?",
        a: "The campus is roughly three hours from Ranchi by road, with convenient train connections between Ranchi and Bokaro Steel City.",
      },
      {
        q: "Do outstation students from Ranchi get admission support?",
        a: "Yes. Our counsellors guide outstation students and families through eligibility, documents and enrolment — start with a call to +91 70913 55794.",
      },
      {
        q: "What programs can students from Ranchi apply for?",
        a: "B.Sc. Nursing (4 years), GNM (3 years) and ANM (2 years) — 60 seats each, admissions open for 2026-27.",
      },
      {
        q: "Is SVS College of Nursing recognised?",
        a: "Yes — recognised by the Indian Nursing Council and the Jharkhand Nurses Registration Council, and affiliated to BBMKU, Dhanbad.",
      },
    ],
  },
};
